
import { CompoundDto, CreateCompoundDto, UpdateCompoundDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { compoundService, CompoundsFilters } from '@services/CompoundService'

const { reducer, actions, thunks } = baseCrudReducer<
  CompoundDto,
  CreateCompoundDto,
  UpdateCompoundDto,
  CompoundsFilters
>('compound', compoundService)

export default reducer

export const { setFilters: setCompoundFilters } = actions

export const {
  getAll: getCompounds,
  create: createCompound,
  update: updateCompound,
  remove: removeCompound,
} = thunks
